import { asImageSrc, asLink, isFilled } from "@prismicio/helpers";
import { typedBoolean } from "../helper";
export const buildTweakwiseVisuals = ({ body, }) => body
    .map((slice) => {
    switch (slice.slice_type) {
        case "base": {
            if (!isFilled.keyText(slice.primary.tweakwise_item_id))
                return;
            if (!isFilled.keyText(slice.primary.tweakwise_item_name))
                return;
            if (!isFilled.link(slice.primary.tweakwise_item_url))
                return;
            if (!isFilled.image(slice.primary.tweakwise_item_image))
                return;
            if (!slice.primary.enable)
                return;
            return {
                id: slice.primary.tweakwise_item_id,
                name: slice.primary.tweakwise_item_name,
                image: asImageSrc(slice.primary.tweakwise_item_image),
                url: asLink(slice.primary.tweakwise_item_url),
                attributes: [
                    {
                        name: "extension",
                        value: JSON.stringify({ visual_type: "base" }),
                    },
                    { name: "item_type", value: "visual" },
                ],
            };
        }
        default:
            return;
    }
})
    .filter(typedBoolean)
    .flat();
